import PropTypes from 'prop-types';

export const props = {
  params: PropTypes.shape({}),
};

export const defaultProps = {
  params: {},
};
